import * as React from "react";
import cx from "classnames";

export interface WizardNavItemDerivedState {
  active: boolean;
  disabled: boolean;
  checked: boolean;
}

export interface WizardNavItemProps extends WizardNavItemDerivedState {
  text: string;
  step: string;
  onClick: () => void;
}

const WizardNavItem = (props: WizardNavItemProps) => (
  <li className={cx({ "is-active": props.active })}>
    <button
      className="wizard-nav-btn"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.checked && !props.active ? (
        <i className="fa fa-check" />
      ) : (
        props.step
      )}
    </button>
    <p>{props.text}</p>
  </li>
);

export default WizardNavItem;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/NavItem.tsx